import { useState } from "react";
import Plot from "react-plotly.js";
import { ColorPicker } from "shared-component/color-picker";

type PieChartProps = {
  data: any;
  layout: any;
};
const PieChart = (props: PieChartProps) => {
  const [defaultColorList, setDefaultColorList] = useState([]);
  const [defaultColorLabels, setDefaultColorLabels] = useState([]);
  const updateLineColor = (value: string, index: number) => {
    const currentSurface: any = document.getElementsByClassName('surface')[index];
    if (currentSurface) {
      currentSurface.style.fill = value
    }
  }

  setTimeout(() => {
    const defaultLegendPie: any = document.getElementsByClassName('legendpie');
    const defaultlegendText: any = document.getElementsByClassName('legendtext');
    let colorList: any = [];
    let colorLabels: any = [];
    for (let item of defaultLegendPie) {
      colorList.push(item?.style?.fill)
    }
    for (let item of defaultlegendText) {
      colorLabels.push(item?.innerHTML)
    }
    setDefaultColorLabels(colorLabels)
    setDefaultColorList(colorList)
  }, 1000)

  return (
    <>
      <Plot
        data={props.data}
        layout={props.layout}
        config={{ displayModeBar: false }}
      />
      {props.data?.length > 0 && defaultColorList?.length > 0 && defaultColorLabels?.length > 0 && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "center" }}>
        {defaultColorLabels?.map((item: any, index: number) => {
          return (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "center" }}>
              <span>{`${item}:`}</span>
              <span><ColorPicker defaulColor={defaultColorList[index]} setChartColor={updateLineColor} index={index} /></span>
            </div>
          )
        })}
      </div>
      }
    </>
  );
};

export default PieChart;